module.exports = __webpack_public_path__ + "static/media/magazine boton.8201c47b.png";